import React, { useState, useEffect, useRef } from 'react'
import { apiClient } from '../../utils/api-config'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth'
import { useHistory } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  FormText
} from 'reactstrap'
import { message } from 'antd'
import { resolveError } from '../../components/Errors/ErrorSummary'
require('../firebase')

export default function Login() {
  const [mynumber, setnumber] = useState('')
  const [otp, setotp] = useState('')
  const [show, setshow] = useState(false)
  const [error, setError] = useState(false)
  const [final, setfinal] = useState('')
  const [validationError, setValidationError] = useState(false)
  const codeInputRef = useRef(null)
  const history = useHistory()
  const auth = getAuth()
  auth.languageCode = 'sv'

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      'size': 'invisible',
      'callback': (result) => {
        console.log(result)
      }
    }, auth)
  }, [])

  useEffect(() => {
    if(show && codeInputRef.current)
      codeInputRef.current.focus()
  }, [show])

  const signin = () => {

    if (mynumber === '' || mynumber.length < 10) {
      return
    } else {
      var number = fomatNumber(mynumber)
      if (testNumber(number)) {
        setValidationError(false)
        const appVerifier = window.recaptchaVerifier
        signInWithPhoneNumber(auth, number, appVerifier).then((confirmationResult) => {
          setfinal(confirmationResult)
          setshow(true)
        })
          .catch((err) => {
            alert(err)
            window.location.reload()
          })
      }
    }
  }

  const validateOtp = () => {
    if (otp === null || final === null)
      return

    final.confirm(otp).then(async (result) => {
      const response = await apiClient.post('/users/logon', null, {
        headers: { Authorization: `Bearer ${result._tokenResponse.idToken}` }
      })

      if(response?.data?.granted === true) {
        sessionStorage.setItem('accessToken', JSON.stringify(result._tokenResponse.idToken))
        sessionStorage.setItem('user', JSON.stringify(result.user))
        
        if(response?.data?.user) {
          sessionStorage.setItem('appUser', JSON.stringify(response.data.user))
        }
        
        history.push('/admin/reports')
      } else {
        message.error('Du måste vara inloggad som administratör.', 6)
        setotp('')
        setshow(false)
      }
    }).catch((err) => {
      if(err.isAxiosError) {
        resolveError(err)
        setshow(false)
      } else {
        setError(true)
      }
      setotp('')
      sessionStorage.clear()
      localStorage.clear()
    })
  }

  const fomatNumber = (number) => {
    if (number.substring(0, 2) == '00') {
      number = '+' + number.substring(2, number.length)
    }
    else if (number.substring(0, 1) == '0') {
      number = '+46' + number.substring(1, number.length)
    }

    return number
  }

  const testNumber = (number) => {

    console.log ('Number ', number, mynumber)
    if (/\+(?:[0-9]●?){10,10}[0-9]$/.test(number)) {
      setValidationError(false)
      return true
    } else {
      setValidationError(true)
      return false
    }
  }

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0 logincard">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <h3 className="plingot-admin-title">Mötesglädje</h3>
              <small>Admin</small>
            </div>
            <div className="text-center text-muted mb-4">
              <small>Logga in med</small>
            </div>
            <Form role="form">
              <FormGroup style={{ display: !show ? 'block' : 'none' }}>
                <InputGroup className={mynumber ? 'input-group-alternative filledintext' : 'input-group-alternative'}>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-mobile-button" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Telefonnummer"
                    type="text"
                    value={mynumber}
                    onChange={(e) => {setnumber(e.target.value); setValidationError(false)}}
                    name="phone"
                    autoComplete="new-password"
                    onKeyPress={(target) => {
                      if (target.charCode === 13) {
                        signin()
                      }
                    }
                    }
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup style={{ display: show ? 'block' : 'none' }}>
                <InputGroup className={mynumber ? 'input-group-alternative filledintext' : 'input-group-alternative'}>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Verifieringskod"
                    type="text"
                    innerRef={codeInputRef}
                    value={otp}
                    onChange={(e) => setotp(e.target.value)}
                    name="otp"
                    autoComplete="new-password"
                    onKeyPress={(target) => {
                      if (target.charCode === 13) {
                        validateOtp()
                      }
                    }
                    }
                  />
                </InputGroup>
              </FormGroup>
              {error ? (
                <>
                  <FormText color="muted">
                      Telefon eller 2 stegs kod var felaktigt. Försök igen.
                  </FormText>
                </>
              ) : (
                validationError ? (
                  <>
                    <FormText color="muted">
                        Telefonnumret validerade inte. Ange rätt telefonnummer.
                    </FormText>
                  </>
                ) : null
              )}
              <div id="recaptcha-container"
                data-sitekey="AIzaSyCJgKgqsWaFx_bPh6QVxgqNmQNFxqFZ494"
                data-callback="sendForm"
                data-size="invisible">
              </div>
              <div style={{ display: !show ? 'block' : 'none' }} className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="button"
                  onClick={signin}
                >
                    Skicka kod
                </Button>
              </div>
              <div style={{ display: show ? 'block' : 'none' }} className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="button"
                  onClick={validateOtp}
                >
                    Logga in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  )
}
